import { render, staticRenderFns } from "./CreateConfigureShiftWorkOld.vue?vue&type=template&id=86a4d39a&scoped=true"
import script from "./CreateConfigureShiftWorkOld.vue?vue&type=script&lang=js"
export * from "./CreateConfigureShiftWorkOld.vue?vue&type=script&lang=js"
import style0 from "./CreateConfigureShiftWorkOld.vue?vue&type=style&index=0&id=86a4d39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a4d39a",
  null
  
)

export default component.exports